<template>
  <b-modal
    ref="modalTermoAceite"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    :hide-header-close="true"
    size="lg"
    dialog-class="swal-like-dialog"
    content-class="swal-like-content"
  >
    <div class="termo-container">

      <!-- Ícone topo -->
      <div class="termo-icon-top">
        <font-awesome-icon icon="fa-solid fa-exclamation" />
      </div>

      <!-- Título -->
      <h4 class="termo-titulo">
        <font-awesome-icon icon="fa-regular fa-clipboard" style="margin-right: 0.5rem;" class="text-center" />
        {{ termoAtual.titulo }}
      </h4>

      <!-- Conteúdo -->
      <div
        class="termo-conteudo"
        v-html="termoAtual.conteudo"
      />

      <!-- Checkbox -->
      <b-form-checkbox
        v-model="confirmado"
        class="termo-checkbox"
      >
        {{ termoAtual.textoCheckbox }}
      </b-form-checkbox>

      <!-- Assinatura -->
      <div class="termo-assinatura">
        Atenciosamente, Equipe Monitor Contábil
      </div>

      <!-- Botão -->
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          class="termo-botao"
          :disabled="aceitando || !confirmado"
          @click="aceitar"
        >
          <b-spinner
            v-if="aceitando"
            small
            class="mr-50"
          />
          Confirmar Autorização
        </b-button>
      </div>

    </div>
  </b-modal>
</template>

<script>
import { BButton, BSpinner, BFormCheckbox } from 'bootstrap-vue'
import { onMounted, onBeforeUnmount, ref } from '@vue/composition-api'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
import api from '@/app/shared/services/api-termos'

export default {
  name: 'ModalTermoAceite',
  components: {
    BButton,
    BSpinner,
    BFormCheckbox,
  },
  setup(_, { refs }) {
    const fila = ref([])
    const termoAtual = ref({ titulo: '', conteudo: '', textoCheckbox: '' })
    const aceitando = ref(false)
    const confirmado = ref(false)

    function exibirProximo() {
      if (fila.value.length === 0) return
      const [primeiro] = fila.value
      termoAtual.value = primeiro
      confirmado.value = false
      refs.modalTermoAceite.show()
    }

    async function receberTermos(payload) {
      if (!payload || payload.length === 0) return
      try {
        if (typeof payload[0] === 'number') {
          // Lista de IDs de tipo enviada por telas (ex.: Analítico) — busca dados via REST
          const { data } = await api.getPendentes(payload)
          if (!data || data.length === 0) return
          fila.value = [...data]
        } else {
          // Objetos completos enviados diretamente pelo backend via SignalR
          fila.value = [...payload]
        }
        exibirProximo()
      } catch {
        // Silencioso — não bloqueia o fluxo da tela
      }
    }

    async function aceitar() {
      if (!confirmado.value) return
      aceitando.value = true
      try {
        await api.aceitar(termoAtual.value.id)
        const tipoAceito = termoAtual.value.tipo
        fila.value.shift()
        refs.modalTermoAceite.hide()
        EventBus.$emit('termoAceito', tipoAceito)
        if (fila.value.length > 0) {
          setTimeout(() => exibirProximo(), 300)
        } else {
          EventBus.$emit('todosTermosAceitos')
        }
      } catch {
        // Silencioso — o usuário pode tentar novamente
      } finally {
        aceitando.value = false
      }
    }

    function bloquearRefresh(e) {
      if (fila.value.length > 0) {
        const evt = e
        evt.preventDefault()
        evt.returnValue = ''
      }
    }

    onMounted(() => {
      EventBus.$on('termosPendentes', receberTermos)
      window.addEventListener('beforeunload', bloquearRefresh)
    })

    onBeforeUnmount(() => {
      EventBus.$off('termosPendentes', receberTermos)
      window.removeEventListener('beforeunload', bloquearRefresh)
    })

    return {
      termoAtual,
      aceitando,
      confirmado,
      aceitar,
    }
  },
}
</script>

<style scoped>
.termo-container {
  padding: 1.5rem 2rem;
  text-align: center;
}

/* Ícone topo */
.termo-icon-top {
  width: 75px;
  height: 75px;
  margin: 0 auto 1rem auto;
  border-radius: 50%;
  border: 4px solid #f97316;
  color: #f97316;
  font-size: 2.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Título */
.termo-titulo {
  color: #f97316;
  font-weight: 600;
  font-size: 1.5rem;
  margin: 2rem;
}

/* Conteúdo */
.termo-conteudo {
  text-align: left;
  font-size: 0.95rem;
  line-height: 1.7;
  color: #333;
  margin-bottom: 1rem;
}

/* Lista */
::v-deep .termo-conteudo ul {
  padding-left: 1.2rem;
}

/* Checkbox */
::v-deep .termo-checkbox label {
  font-weight: 600;
  color: #000;
}

/* Assinatura */
.termo-assinatura {
  margin-top: 1.5rem;
  font-weight: 600;
  color: #1f2937;
}

/* Botão */
.termo-botao {
  padding: 0.45rem 1.4rem;
  border-radius: 6px;
  font-weight: 500;
}
</style>
